module.exports = __webpack_public_path__ + "img/icons-16-export.2ec2693a.svg";